import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import NoxTable from '../../component/Table';
import {
  fetchAllTransactionsAction,
  downloadMyCoinsTransactionsAction
} from '../../actions/myCoins';
import InnerHeader from '../../component/InnerHeader';
import Loader from '../../component/Loader/Loader';
import Copy from '../../component/Copy';
import formatDate from '../../helpers/formatDate';

const MyCoins = () => {
  const dispatch = useDispatch();
  const currentProject = useSelector(({ project }) => project.currentProject);

  const onDownloadCsv = () => {
    dispatch(downloadMyCoinsTransactionsAction());
  };

  useEffect(() => {
    async function load() {
      dispatch(fetchAllTransactionsAction());
    }

    if (currentProject) {
      load();
    }
  }, [currentProject, dispatch]);

  const mapToTable = (customTypes) => {
    const data = [];

    if (!customTypes || customTypes.length === 0) {
      return data;
    }

    customTypes.forEach(
      ({ phoneNumber, rate, amount, payout, btc, tx, date, description }, index) => {
        const finalDate = formatDate(date);

        data.push({
          amount: `${amount} ₾`,
          btc: `${btc} ₿`,
          description,
          key: index,
          payout,
          phone: phoneNumber,
          rate,
          registeredAt: finalDate,
          tx
        });
      }
    );

    return data;
  };

  const columns = [
    {
      dataIndex: 'phone',
      key: 'phone',
      render: (id) => {
        return (
          <div
            style={{
              color: 'black',
              fontWeight: 700
            }}
          >
            <Copy text={id} />
          </div>
        );
      },
      sorter: (a, b) => a.id.localeCompare(b.id),
      title: 'Phone'
    },
    {
      dataIndex: 'rate',
      key: 'rate',
      render: (rate) => {
        return <Copy text={rate} />;
      },
      sorter: (a, b) => a.rate.toString().localeCompare(b.rate),
      title: 'Rate'
    },
    {
      dataIndex: 'amount',
      key: 'amount',
      render: (amount) => {
        return <Copy text={amount} />;
      },
      sorter: (a, b) => a.amount.toString().localeCompare(b.amount),
      title: 'Amount GEL'
    },
    {
      dataIndex: 'btc',
      key: 'btc',
      render: (btc) => {
        return <Copy text={btc} />;
      },
      sorter: (a, b) => a.btc.toString().localeCompare(b.btc),
      title: 'Amount BTC'
    },
    {
      dataIndex: 'payout',
      key: 'payout',
      render: (payout) => {
        return <Copy text={payout} />;
      },
      sorter: (a, b) => a.payout.toString().localeCompare(b.payout),
      title: 'Payout'
    },
    {
      dataIndex: 'tx',
      key: 'tx',
      render: (tx) => {
        return <Copy text={tx} />;
      },
      sorter: (a, b) => a.tx.toString().localeCompare(b.tx),
      title: 'Tx'
    },
    {
      dataIndex: 'description',
      key: 'description',
      render: (description) => {
        return <Copy text={description} />;
      },
      sorter: (a, b) => a.description.toString().localeCompare(b.description),
      title: 'Description'
    },
    {
      dataIndex: 'registeredAt',
      key: 'registeredAt',
      render: (registeredAt) => {
        return <Copy text={registeredAt} />;
      },
      sorter: (a, b) => new Date(a.registeredAt) - new Date(b.registeredAt),
      title: 'Registered At'
    }
  ];

  const actions = [
    {
      onClick: onDownloadCsv,
      title: 'Download CSV',
      type: 'primary'
    }
  ];

  const allTransactions = useSelector(({ myCoins }) => myCoins.allTransactions);
  const data = mapToTable(allTransactions);

  const filteredData = data;

  if (!currentProject) {
    return <Loader />;
  }

  return (
    <div
      style={{
        height: 'calc(100vh - 165px)',
        overflowY: 'scroll'
      }}
    >
      <InnerHeader subtitle={data.length} title="Transactions" />
      <NoxTable
        actions={actions}
        checkbox={false}
        columns={columns}
        data={filteredData}
        searchBy="phone"
      />
    </div>
  );
};

export default MyCoins;
